(function(){
  'use strict';

  var drawer, overlay, itemsEl, emptyEl, filledEl, footerEl, subtotalEl, loadingEl;
  var busy = false;

  function money(cents, currency){
    cents = Number(cents || 0);
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.money_format) {
        return Shopify.formatMoney(cents, window.money_format);
      }
    } catch(e) {}
    try {
      return new Intl.NumberFormat('en-US', {style:'currency', currency: currency || 'USD'}).format(cents / 100);
    } catch(e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function escapeUrl(url){
    return typeof url === 'string' ? url : '#';
  }

  function setOpen(open){
    if (!drawer) return;
    document.documentElement.classList.toggle('pp-cart-open', !!open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (overlay) overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  function open(){ setOpen(true); }
  function close(){ setOpen(false); }

  function button(label, cls){
    var el = document.createElement('button');
    el.type = 'button';
    el.className = cls;
    el.textContent = label;
    return el;
  }

  function render(cart){
    if (!itemsEl) return;
    itemsEl.textContent = '';
    var count = Number(cart.item_count || 0);
    document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = count; });

    if (!count) {
      emptyEl.hidden = false;
      filledEl.hidden = true;
      footerEl.hidden = true;
      return;
    }

    emptyEl.hidden = true;
    filledEl.hidden = false;
    footerEl.hidden = false;
    subtotalEl.textContent = money(cart.total_price, cart.currency || 'USD');

    (cart.items || []).forEach(function(item){
      var li = document.createElement('li');
      li.className = 'pp-cart-drawer__item';
      li.dataset.key = item.key || item.id;

      var imageLink = document.createElement('a');
      imageLink.className = 'pp-cart-drawer__image';
      imageLink.href = escapeUrl(item.url);
      var img = document.createElement('img');
      var image = item.image || (item.featured_image && item.featured_image.url) || '';
      img.src = image;
      img.alt = item.product_title || item.title || '';
      img.loading = 'lazy';
      imageLink.appendChild(img);

      var details = document.createElement('div');
      details.className = 'pp-cart-drawer__details';
      var title = document.createElement('a');
      title.className = 'pp-cart-drawer__title';
      title.href = escapeUrl(item.url);
      title.textContent = item.product_title || item.title || 'Item';
      details.appendChild(title);

      if (item.variant_title && item.variant_title !== 'Default Title') {
        var variant = document.createElement('div');
        variant.className = 'pp-cart-drawer__variant';
        variant.textContent = item.variant_title;
        details.appendChild(variant);
      }

      var row = document.createElement('div');
      row.className = 'pp-cart-drawer__row';
      var qty = document.createElement('div');
      qty.className = 'pp-cart-drawer__qty';
      var minus = button('−', 'pp-cart-drawer__minus');
      minus.setAttribute('aria-label','Decrease quantity');
      minus.dataset.ppCartQty = String(Math.max(0, Number(item.quantity || 1) - 1));
      var num = document.createElement('span');
      num.textContent = item.quantity || 1;
      var plus = button('+', 'pp-cart-drawer__plus');
      plus.setAttribute('aria-label','Increase quantity');
      plus.dataset.ppCartQty = String(Number(item.quantity || 1) + 1);
      qty.appendChild(minus); qty.appendChild(num); qty.appendChild(plus);

      var price = document.createElement('div');
      price.className = 'pp-cart-drawer__price';
      price.textContent = money(item.final_line_price != null ? item.final_line_price : (item.line_price || item.price), cart.currency || 'USD');
      row.appendChild(qty); row.appendChild(price);
      details.appendChild(row);

      var remove = button('Remove', 'pp-cart-drawer__remove');
      remove.dataset.ppCartRemove = '1';
      details.appendChild(remove);

      li.appendChild(imageLink); li.appendChild(details); itemsEl.appendChild(li);
    });
  }

  function setLoading(value){
    busy = !!value;
    if (loadingEl) loadingEl.hidden = !busy;
    if (drawer) drawer.classList.toggle('is-loading', busy);
  }

  function fetchCart(){
    return fetch('/cart.js', {credentials:'same-origin', headers:{'Accept':'application/json'}})
      .then(function(res){ if(!res.ok) throw new Error('cart'); return res.json(); })
      .then(function(cart){ render(cart); return cart; });
  }

  function refresh(){ return fetchCart(); }

  function refreshAndOpen(){
    open();
    setLoading(true);
    return fetchCart().catch(function(){ /* keep drawer available even if refresh fails */ }).then(function(){ setLoading(false); });
  }

  function change(key, quantity){
    if (busy) return;
    setLoading(true);
    fetch('/cart/change.js', {
      method:'POST', credentials:'same-origin',
      headers:{'Accept':'application/json','Content-Type':'application/json'},
      body:JSON.stringify({id:key, quantity:Math.max(0, Number(quantity || 0))})
    })
    .then(function(res){ if(!res.ok) throw new Error('change'); return res.json(); })
    .then(render)
    .catch(function(){ return fetchCart(); })
    .finally(function(){ setLoading(false); });
  }

  function init(){
    drawer = document.querySelector('[data-pp-cart-drawer]');
    overlay = document.querySelector('[data-pp-cart-overlay]');
    if (!drawer) return;
    itemsEl = drawer.querySelector('[data-pp-cart-items]');
    emptyEl = drawer.querySelector('[data-pp-cart-empty]');
    filledEl = drawer.querySelector('[data-pp-cart-filled]');
    footerEl = drawer.querySelector('[data-pp-cart-footer]');
    subtotalEl = drawer.querySelector('[data-pp-cart-subtotal]');
    loadingEl = drawer.querySelector('[data-pp-cart-loading]');

    drawer.addEventListener('click', function(e){
      var closeBtn = e.target.closest('[data-pp-cart-close]');
      if (closeBtn) { e.preventDefault(); close(); return; }
      var item = e.target.closest('.pp-cart-drawer__item');
      if (!item) return;
      var qtyBtn = e.target.closest('[data-pp-cart-qty]');
      if (qtyBtn) { e.preventDefault(); change(item.dataset.key, qtyBtn.dataset.ppCartQty); return; }
      var removeBtn = e.target.closest('[data-pp-cart-remove]');
      if (removeBtn) { e.preventDefault(); change(item.dataset.key, 0); }
    });
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });

    /* Make every header cart icon open this drawer, on desktop and mobile. */
    document.addEventListener('click', function(e){
      var toggle = e.target.closest && e.target.closest('[data-cart-toggle]');
      if (!toggle) return;
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      refreshAndOpen();
    }, true);

    /* Standard theme add-to-cart uses jQuery AJAX when ajax_popup_cart = normal. */
    if (window.jQuery) {
      window.jQuery(document).off('ajaxComplete.ppCartDrawer').on('ajaxComplete.ppCartDrawer', function(event, xhr, settings){
        var url = settings && settings.url ? String(settings.url) : '';
        if (/\/cart\/add(?:\.js)?(?:\?|$)/.test(url)) {
          window.setTimeout(refreshAndOpen, 60);
        }
      });
    }

    refresh();
  }

  window.PPCartDrawer = {
    open: open,
    close: close,
    refresh: refresh,
    refreshAndOpen: refreshAndOpen
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
